// import * as angular from 'angular';
import { SdcFluxModule } from '../../sdc/flux/sdc-flux.module';
import nvSharedModelsModule from '../../shared/models/nv.shared.models.module';
import { callbackRoute } from './callback.route';
import { NewSdcRoutesModule } from './new-sdc/new-sdc-routes.module';

angular
  .module('nv.routes.main', [
    'ui.router',
    'nv.routes.config',
    nvSharedModelsModule,
    'nv.shared.services.shared-state',
    'nv.SchoolMetricsModule',
    'nv.routes.errors',
    SdcFluxModule,
    NewSdcRoutesModule,
  ])
  .config(callbackRoute);
